import listActions from 'src/modules/wellnessCheck/list/wellnessCheckListActions';
import WellnessCheckService from 'src/modules/wellnessCheck/wellnessCheckService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'WELLNESS_CHECK_DESTROY';

const wellnessCheckDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: wellnessCheckDestroyActions.DESTROY_STARTED,
      });

      await WellnessCheckService.destroyAll([id]);

      dispatch({
        type: wellnessCheckDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.wellnessCheck.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/wellness-check');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: wellnessCheckDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: wellnessCheckDestroyActions.DESTROY_ALL_STARTED,
      });

      await WellnessCheckService.destroyAll(ids);

      dispatch({
        type: wellnessCheckDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.wellnessCheck.destroyAll.success'),
      );

      getHistory().push('/wellness-check');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: wellnessCheckDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default wellnessCheckDestroyActions;
